export default {
  eventId: {
    'ui:widget': 'EditorEventWidget',
  },
}
